import { LEAN_TYPE_NUM_TO_STR } from "../../../Constants/constant";
import { controls } from "../../../redux/reducers/common/eventReducer";
import { const_var, params } from "../../../redux/reducers/reducer";
import { makeTranslucent } from "../../building/building_config/componentConfig";
import * as cuComponent from "../../../redux/reducers/building_component/componentReducer";
import * as cuBuilding from "../../../redux/reducers/building_pricing/pricingReducer";

export const calcWallCost = (paramsData, calcfor, wall, costObj, isLean = "", leanToLength, lowerHeight = 0, isCenterBuidling = false, wallname = "") => {
	let Price = 0;

	if (calcfor == "side" && isLean == "") {
		let exactHeight = lowerHeight != 0 ? lowerHeight : paramsData.p_h;
		let exactLength = paramsData.p_d;

		if (isCenterBuidling == true && wall != "Close" && wallname == "leftwall" && paramsData.add_storage_check == true) {
			Price = parseFloat(paramsData.add_storage * exactHeight * costObj.cost);
			exactLength = parseFloat(paramsData.p_d) - parseFloat(paramsData.add_storage);
		}

		if (isCenterBuidling == true && wall != "Close" && wallname == "rightwall" && paramsData.add_storage_check_right == true) {
			Price = parseFloat(paramsData.add_storage_right * exactHeight * costObj.cost);
			exactLength = parseFloat(paramsData.p_d) - parseFloat(paramsData.add_storage_right);
		}
		if (wall == "One_Fourth_Close") {
			Price = parseFloat(Price) + parseFloat(exactLength * ((1 / 4) * parseInt(exactHeight)) * costObj.cost);
		} else if (wall == "Half_Close") {
			Price = parseFloat(Price) + parseFloat(exactLength * ((1 / 2) * parseInt(exactHeight)) * costObj.cost);
		} else if (wall == "Three_Fourth_Close") {
			Price = parseFloat(Price) + parseFloat(exactLength * ((3 / 4) * parseInt(exactHeight)) * costObj.cost);
		} else if (wall != "Close") {
			Price = parseFloat(Price) + parseFloat(exactLength * (parseInt(wall) * 3) * costObj.cost);
		} else {
			Price = parseFloat(Price) + parseFloat(exactLength * exactHeight * costObj.cost);
		}
	}
	// center building end wall calculation
	if (calcfor == "end" && isLean == "") {
		let actualWidth = paramsData.p_w;
		if (isCenterBuidling == true && wall != "Close" && wallname == "frontwall" && paramsData.add_storage_check_front == true) {
			if (params.m_s_n == 93) {
				Price = parseFloat((parseInt(paramsData.p_h) + 1.5) * paramsData.add_storage_front * costObj.cost);
			} else {
				Price = parseFloat((parseInt(paramsData.p_h) + 1) * paramsData.add_storage_front * costObj.cost);
			}
			actualWidth = paramsData.p_w - paramsData.add_storage_front;
		}
		if (isCenterBuidling == true && wall != "Close" && wallname == "backwall" && paramsData.add_storage_check_back == true) {
			if (params.m_s_n == 93) {
				Price = parseFloat((parseInt(paramsData.p_h) + 1.5) * paramsData.add_storage_back * costObj.cost);
			} else {
				Price = parseFloat((parseInt(paramsData.p_h) + 1) * paramsData.add_storage_back * costObj.cost);
			}
			actualWidth = paramsData.p_w - paramsData.add_storage_back;
		}
		if (wall == "Extended Gable") {
			Price = parseFloat(Price) + parseFloat(6 * actualWidth * costObj.cost);
		} else if (wall == "Gable") {
			Price = parseFloat(Price) + parseFloat(3 * actualWidth * costObj.cost);
		} else if (wall == "One_Fourth_Close") {
			Price = parseFloat(Price) + parseFloat((1 / 4) * parseInt(paramsData.p_h) * actualWidth * costObj.cost);
		} else if (wall == "Half_Close") {
			Price = parseFloat(Price) + parseFloat((1 / 2) * parseInt(paramsData.p_h) * actualWidth * costObj.cost);
		} else if (wall == "Three_Fourth_Close") {
			Price = parseFloat(Price) + parseFloat((3 / 4) * parseInt(paramsData.p_h) * actualWidth * costObj.cost);
		} else {
			if (params.p_b_t == 27 || params.p_b_t == 33) {
				Price = parseFloat(parseInt(paramsData.p_h) * paramsData.p_w * costObj.cost);
			} else {
				if (params.m_s_n == 93) {
					Price = parseFloat(Price) + parseFloat((parseInt(paramsData.p_h) + 1.5) * actualWidth * costObj.cost);
				} else {
					Price = parseFloat(Price) + parseFloat((parseInt(paramsData.p_h) + 1) * actualWidth * costObj.cost);
				}
			}
		}
	}
	// front lean-to side wall calculation
	if (calcfor == "side" && isLean == "front") {
		if (wall == "One_Fourth_Close") {
			Price = parseFloat(leanToLength * ((1 / 4) * parseInt(paramsData.leanF_p_h)) * costObj.cost);
		} else if (wall == "Half_Close") {
			Price = parseFloat(leanToLength * ((1 / 2) * parseInt(paramsData.leanF_p_h)) * costObj.cost);
		} else if (wall == "Three_Fourth_Close") {
			Price = parseFloat(leanToLength * ((3 / 4) * parseInt(paramsData.leanF_p_h)) * costObj.cost);
		} else if (wall != "Close") {
			Price = parseFloat(leanToLength * (parseInt(wall) * 3) * costObj.cost);
		} else {
			Price = parseFloat(leanToLength * paramsData.leanF_p_h * costObj.cost);
		}
	}
	// front lean-to end wall calculation
	if (calcfor == "end" && isLean == "front") {
		if (wall == "Extended Gable") {
			Price = parseFloat(6 * paramsData.leanF_p_w * costObj.cost);
		} else if (wall == "Gable") {
			Price = parseFloat(3 * paramsData.leanF_p_w * costObj.cost);
		} else if (wall == "One_Fourth_Close") {
			Price = parseFloat((1 / 4) * parseInt(paramsData.leanF_p_h) * paramsData.leanF_p_w * costObj.cost);
		} else if (wall == "Half_Close") {
			Price = parseFloat((1 / 2) * parseInt(paramsData.leanF_p_h) * paramsData.leanF_p_w * costObj.cost);
		} else if (wall == "Three_Fourth_Close") {
			Price = parseFloat((3 / 4) * parseInt(paramsData.leanF_p_h) * paramsData.leanF_p_w * costObj.cost);
		} else {
			if (params.p_b_t == 27 || params.p_b_t == 33) {
				Price = parseFloat(paramsData.leanF_p_h * paramsData.leanF_p_w * costObj.cost);
			} else {
				if (params.m_s_n == 93) {
					Price = parseFloat((paramsData.leanF_p_h + 1.5) * paramsData.leanF_p_w * costObj.cost);
				} else {
					Price = parseFloat((paramsData.leanF_p_h + 1) * paramsData.leanF_p_w * costObj.cost);
				}
			}
		}
	}
	// back lean-to side wall calculation
	if (calcfor == "side" && isLean == "back") {
		if (wall == "One_Fourth_Close") {
			Price = parseFloat(leanToLength * ((1 / 4) * parseInt(paramsData.leanB_p_h)) * costObj.cost);
		} else if (wall == "Half_Close") {
			Price = parseFloat(leanToLength * ((1 / 2) * parseInt(paramsData.leanB_p_h)) * costObj.cost);
		} else if (wall == "Three_Fourth_Close") {
			Price = parseFloat(leanToLength * ((3 / 4) * parseInt(paramsData.leanB_p_h)) * costObj.cost);
		} else if (wall != "Close") {
			Price = parseFloat(leanToLength * (parseInt(wall) * 3) * costObj.cost);
		} else {
			Price = parseFloat(leanToLength * paramsData.leanB_p_h * costObj.cost);
		}
	}
	// back lean-to end wall calculation
	if (calcfor == "end" && isLean == "back") {
		if (wall == "Gable") {
			Price = parseFloat(3 * paramsData.leanB_p_w * costObj.cost);
		} else if (wall == "One_Fourth_Close") {
			Price = parseFloat((1 / 4) * parseInt(paramsData.leanB_p_h) * paramsData.leanB_p_w * costObj.cost);
		} else if (wall == "Half_Close") {
			Price = parseFloat((1 / 2) * parseInt(paramsData.leanB_p_h) * paramsData.leanB_p_w * costObj.cost);
		} else if (wall == "Three_Fourth_Close") {
			Price = parseFloat((3 / 4) * parseInt(paramsData.leanB_p_h) * paramsData.leanB_p_w * costObj.cost);
		} else {
			if (params.p_b_t == 27 || params.p_b_t == 33) {
				Price = parseFloat(paramsData.leanB_p_h * paramsData.leanB_p_w * costObj.cost);
			} else {
				if (params.m_s_n == 93) {
					Price = parseFloat((paramsData.leanB_p_h + 1.5) * paramsData.leanB_p_w * costObj.cost);
				} else {
					Price = parseFloat((paramsData.leanB_p_h + 1) * paramsData.leanB_p_w * costObj.cost);
				}
			}
		}
	}
	// left lean-to side wall calculation
	if (calcfor == "side" && isLean == "left") {
		if (wall == "One_Fourth_Close") {
			Price = parseFloat(leanToLength * ((1 / 4) * parseInt(paramsData.lean_p_h)) * costObj.cost);
		} else if (wall == "Half_Close") {
			Price = parseFloat(leanToLength * ((1 / 2) * parseInt(paramsData.lean_p_h)) * costObj.cost);
		} else if (wall == "Three_Fourth_Close") {
			Price = parseFloat(leanToLength * ((3 / 4) * parseInt(paramsData.lean_p_h)) * costObj.cost);
		} else if (wall != "Close") {
			Price = parseFloat(leanToLength * (parseInt(wall) * 3) * costObj.cost);
		} else {
			Price = parseFloat(leanToLength * paramsData.lean_p_h * costObj.cost);
		}
	}
	// left lean-to end wall calculation
	if (calcfor == "end" && isLean == "left") {
		if (wall == "Gable") {
			Price = parseFloat(3 * paramsData.lean_p_w * costObj.cost);
		} else if (wall == "One_Fourth_Close") {
			Price = parseFloat((1 / 4) * parseInt(paramsData.lean_p_h) * paramsData.lean_p_w * costObj.cost);
		} else if (wall == "Half_Close") {
			Price = parseFloat((1 / 2) * parseInt(paramsData.lean_p_h) * paramsData.lean_p_w * costObj.cost);
		} else if (wall == "Three_Fourth_Close") {
			Price = parseFloat((3 / 4) * parseInt(paramsData.lean_p_h) * paramsData.lean_p_w * costObj.cost);
		} else {
			if (params.p_b_t == 27 || params.p_b_t == 33) {
				Price = parseFloat(paramsData.lean_p_h * paramsData.lean_p_w * costObj.cost);
			} else {
				if (params.m_s_n == 93) {
					Price = parseFloat((paramsData.lean_p_h + 1.5) * paramsData.lean_p_w * costObj.cost);
				} else {
					Price = parseFloat((paramsData.lean_p_h + 1) * paramsData.lean_p_w * costObj.cost);
				}
			}
		}
	}
	// right lean-to side wall calculation
	if (calcfor == "side" && isLean == "right") {
		if (wall == "One_Fourth_Close") {
			Price = parseFloat(leanToLength * ((1 / 4) * parseInt(paramsData.leanR_p_h)) * costObj.cost);
		} else if (wall == "Half_Close") {
			Price = parseFloat(leanToLength * ((1 / 2) * parseInt(paramsData.leanR_p_h)) * costObj.cost);
		} else if (wall == "Three_Fourth_Close") {
			Price = parseFloat(leanToLength * ((3 / 4) * parseInt(paramsData.leanR_p_h)) * costObj.cost);
		} else if (wall != "Close") {
			Price = parseFloat(leanToLength * (parseInt(wall) * 3) * costObj.cost);
		} else {
			Price = parseFloat(leanToLength * paramsData.leanR_p_h * costObj.cost);
		}
	}
	// right lean-to end wall calculation
	if (calcfor == "end" && isLean == "right") {
		if (wall == "Gable") {
			Price = parseFloat(3 * paramsData.leanR_p_w * costObj.cost);
		} else if (wall == "One_Fourth_Close") {
			Price = parseFloat((1 / 4) * parseInt(paramsData.leanR_p_h) * paramsData.leanR_p_w * costObj.cost);
		} else if (wall == "Half_Close") {
			Price = parseFloat((1 / 2) * parseInt(paramsData.leanR_p_h) * paramsData.leanR_p_w * costObj.cost);
		} else if (wall == "Three_Fourth_Close") {
			Price = parseFloat((3 / 4) * parseInt(paramsData.leanR_p_h) * paramsData.leanR_p_w * costObj.cost);
		} else {
			if (params.p_b_t == 27 || params.p_b_t == 33) {
				Price = parseFloat(paramsData.leanR_p_h * paramsData.leanR_p_w * costObj.cost);
			} else {
				if (params.m_s_n == 93) {
					Price = parseFloat((paramsData.leanR_p_h + 1.5) * paramsData.leanR_p_w * costObj.cost);
				} else {
					Price = parseFloat((paramsData.leanR_p_h + 1) * paramsData.leanR_p_w * costObj.cost);
				}
			}
		}
	}
	return Price;
};
export const findActiveWall = (elementName, constVarControls, section, tab) => {
	let rotAngle = constVarControls != undefined && constVarControls != "" ? constVarControls.getAzimuthalAngle() : 0;

	if (((section != "select" || tab != "doorwindow") && elementName == "canvas" && rotAngle != 0 && rotAngle != Math.PI / 2 && rotAngle != -Math.PI / 2) || tab != "doorwindow") {
		let previousWall = params.activeWall;

		if (-Math.PI / 4 < rotAngle && rotAngle < Math.PI / 4) {
			if (params.p_u_c == true && params.p_f_w != "Close") {
				params.activeWall = "c_b_f_s_w";
			} else {
				params.activeWall = "c_b_f_w";
			}
		} else if (Math.PI / 4 < rotAngle && rotAngle < (3 * Math.PI) / 4) {
			if (params.p_u_c == true && params.p_r_w != "Close") {
				params.activeWall = "c_b_r_s_w";
			} else {
				params.activeWall = "c_b_r_w";
			}
		} else if ((3 * Math.PI) / 4 < rotAngle || rotAngle < (-3 * Math.PI) / 4) {
			if (params.p_u_c == true && params.p_b_w != "Close") {
				params.activeWall = "c_b_b_s_w";
			} else {
				params.activeWall = "c_b_b_w";
			}
		} else if (-Math.PI / 4 > rotAngle && rotAngle > (-3 * Math.PI) / 4) {
			if (params.p_l_w != "Close" && params.p_u_c == true) {
				params.activeWall = "c_b_l_s_w";
			} else {
				params.activeWall = "c_b_l_w";
			}
		}
		const_var.wallSelection.centerBuildingWall = params.activeWall;
		const_var.wallSelection.leanToWall = "select";
		const_var.focusedSection = cuComponent.wallnameBySec[params.activeWall];

		if (
			(previousWall == "c_b_f_s_w" && params.activeWall != "c_b_f_s_w") ||
			(previousWall == "c_b_b_s_w" && params.activeWall != "c_b_b_s_w") ||
			(previousWall == "c_b_l_s_r_w" && params.activeWall != "c_b_l_s_r_w") ||
			(previousWall == "c_b_r_s_l_w" && params.activeWall != "c_b_r_s_l_w")
		)
			makeTranslucent(controls.isCheckActiveTab, params.activeWall, params.is_translusant, const_var.scene);
	}
	return params.activeWall;
};
export const calcNumOfWalls = (isfor, cond) => {
	let sideWallCount = 0;
	let endWallCount = 0;

	if (isfor == "side") {
		if (cond == "1") {
			if (const_var.wallsData["center"].p_l_w != "Open" && const_var.wallsData["center"].p_l_w != "Close") {
				sideWallCount += 1;
			}
			if (const_var.wallsData["center"].p_r_w != "Open" && const_var.wallsData["center"].p_r_w != "Close") {
				sideWallCount += 1;
			}
			if (const_var.wallsData["leftLean"].p_b_c_b_l != "Open" && const_var.wallsData["leftLean"].p_b_c_b_l != "Close") {
				sideWallCount += 1;
			}
			if (const_var.wallsData["rightLean"].p_b_c_b_r != "Open" && const_var.wallsData["rightLean"].p_b_c_b_r != "Close") {
				sideWallCount += 1;
			}
			if (const_var.wallsData["frontLean"].p_b_c_b_f_l != "Open" && const_var.wallsData["frontLean"].p_b_c_b_f_l != "Close") {
				sideWallCount += 1;
			}
			if (const_var.wallsData["backLean"].p_b_c_b_b_l != "Open" && const_var.wallsData["backLean"].p_b_c_b_b_l != "Close") {
				sideWallCount += 1;
			}
		}
		return sideWallCount;
	}
	if (isfor == "end") {
		if (
			const_var.wallsData["center"].p_b_w != "Open" &&
			const_var.wallsData["center"].p_b_w != "Close" &&
			const_var.wallsData["center"].p_b_w != "Half Dutch End" &&
			const_var.wallsData["center"].p_b_w != "Half End"
		) {
			endWallCount += 1;
		}
		if (
			const_var.wallsData["center"].p_f_w != "Open" &&
			const_var.wallsData["center"].p_f_w != "Close" &&
			const_var.wallsData["center"].p_f_w != "Half Dutch End" &&
			const_var.wallsData["center"].p_f_w != "Half End"
		) {
			endWallCount += 1;
		}
		if (
			const_var.wallsData["leftLean"].p_b_c_b_l_b != undefined &&
			const_var.wallsData["leftLean"].p_b_c_b_l_b != "Open" &&
			const_var.wallsData["leftLean"].p_b_c_b_l_b != "Close" &&
			const_var.wallsData["leftLean"].p_b_c_b_l_b != "Half Dutch End" &&
			const_var.wallsData["leftLean"].p_b_c_b_l_b != "Half End"
		) {
			endWallCount += 1;
		}
		if (
			const_var.wallsData["leftLean"].p_b_c_b_l_f != "Open" &&
			const_var.wallsData["leftLean"].p_b_c_b_l_f != "Close" &&
			const_var.wallsData["leftLean"].p_b_c_b_l_f != "Half Dutch End" &&
			const_var.wallsData["leftLean"].p_b_c_b_l_f != "Half End"
		) {
			endWallCount += 1;
		}
		if (
			const_var.wallsData["rightLean"].p_b_c_b_r_b != undefined &&
			const_var.wallsData["rightLean"].p_b_c_b_r_b != "Open" &&
			const_var.wallsData["rightLean"].p_b_c_b_r_b != "Close" &&
			const_var.wallsData["rightLean"].p_b_c_b_r_b != "Half Dutch End" &&
			const_var.wallsData["rightLean"].p_b_c_b_r_b != "Half End"
		) {
			endWallCount += 1;
		}
		if (
			const_var.wallsData["rightLean"].p_b_c_b_r_f != "Open" &&
			const_var.wallsData["rightLean"].p_b_c_b_r_f != "Close" &&
			const_var.wallsData["rightLean"].p_b_c_b_r_f != "Half Dutch End" &&
			const_var.wallsData["rightLean"].p_b_c_b_r_f != "Half End"
		) {
			endWallCount += 1;
		}
		if (
			const_var.wallsData["frontLean"].p_b_c_b_f_b != undefined &&
			const_var.wallsData["frontLean"].p_b_c_b_f_b != "Open" &&
			const_var.wallsData["frontLean"].p_b_c_b_f_b != "Close" &&
			const_var.wallsData["frontLean"].p_b_c_b_f_b != "Half Dutch End" &&
			const_var.wallsData["frontLean"].p_b_c_b_f_b != "Half End"
		) {
			endWallCount += 1;
		}
		if (
			const_var.wallsData["frontLean"].p_b_c_b_f_f != "Open" &&
			const_var.wallsData["frontLean"].p_b_c_b_f_l != "Close" &&
			const_var.wallsData["frontLean"].p_b_c_b_f_f != "Half Dutch End" &&
			const_var.wallsData["frontLean"].p_b_c_b_f_f != "Half End"
		) {
			endWallCount += 1;
		}
		if (
			const_var.wallsData["backLean"].p_b_c_b_b_b != undefined &&
			const_var.wallsData["backLean"].p_b_c_b_b_b != "Open" &&
			const_var.wallsData["backLean"].p_b_c_b_b_b != "Close" &&
			const_var.wallsData["backLean"].p_b_c_b_b_b != "Half Dutch End" &&
			const_var.wallsData["backLean"].p_b_c_b_b_b != "Half End"
		) {
			endWallCount += 1;
		}
		if (
			const_var.wallsData["backLean"].p_b_c_b_b_f != "Open" &&
			const_var.wallsData["backLean"].p_b_c_b_b_f != "Close" &&
			const_var.wallsData["backLean"].p_b_c_b_b_f != "Half Dutch End" &&
			const_var.wallsData["backLean"].p_b_c_b_b_f != "Half End"
		) {
			endWallCount += 1;
		}
		return endWallCount;
	}
};

export const shouldCalculate2 = (leanType) => {
	if (const_var.isLTBuilding) {
		const isGableLeanto = const_var.post_data?.building?.leanto?.find((l) => LEAN_TYPE_NUM_TO_STR[l.leanto_type] === leanType && l.leanto_style === "gable");
		if (isGableLeanto) {
			if (const_var.selectedLeanType === leanType) {
				return true;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
	return true;
};

export const updateWallSelection = (isFor, fullEmpty = false) => {
	if (const_var.insulationPriceJson) {
		const_var.insulationPriceJson.forEach((obj) => {
			if (obj && obj.insulation_wall) {
				let tmpObj = JSON.parse(JSON.stringify(obj.insulation_wall));

				Object.entries(tmpObj).forEach(([key, val]) => {
					if (key == "storage_front" || key == "open_roof" || key == "storage_roof" || key == "storage_right" || key == "storage_left" || key == "storage_back") {
						let storagePosition = "";
						if (params.p_u_c) {
							if (params.endStoragePositionZ === 0) {
								storagePosition = "end";
							} else if (params.endStoragePositionZ === params.p_d - parseInt(params.p_u_t)) {
								storagePosition = "front";
							} else {
								storagePosition = "center";
							}
						}
						if (params.cB_addStorage_check_left || params.p_u_c || params.cB_addStorage_check_right) {
							obj.insulation_wall[key] = val;
							if (key == "storage_left" && tmpObj["storage_left"] == "included" && params.p_l_w != "Close" && params.p_u_c) {
								obj.insulation_wall[key] = true;
							}
							if (key == "storage_right" && tmpObj["storage_right"] == "included" && params.p_r_w != "Close" && params.p_u_c) {
								obj.insulation_wall[key] = true;
							}
							if (key == "storage_front" && tmpObj["storage_front"] == "included" && params.p_u_c) {
								obj.insulation_wall[key] = true;
							}
							if (
								key == "storage_front" &&
								tmpObj["storage_front"] == "included" &&
								params.p_f_w != "Close" &&
								obj.insulation_wall["p_f_w"] != true &&
								(params.cB_addStorage_check_left || params.cB_addStorage_check_right)
							) {
								obj.insulation_wall[key] = true;
							}
							if (
								key == "storage_back" &&
								tmpObj["storage_back"] == "included" &&
								params.p_b_w != "Close" &&
								obj.insulation_wall["p_b_w"] != true &&
								(params.cB_addStorage_check_left || params.cB_addStorage_check_right)
							) {
								obj.insulation_wall[key] = true;
							}
							if (key == "storage_right" && tmpObj["storage_right"] == "included" && params.cB_addStorage_check_left) {
								obj.insulation_wall[key] = false;
							}
							if (key == "storage_left" && tmpObj["storage_left"] == "included" && params.cB_addStorage_check_right) {
								obj.insulation_wall[key] = false;
							}

							if (
								key == "storage_front" &&
								obj.insulation_wall["storage_front"] == false &&
								obj.insulation_wall["p_f_w"] == true &&
								params.p_f_w == "Close" &&
								(params.cB_addStorage_check_left || params.cB_addStorage_check_right)
							) {
								obj.insulation_wall[key] = "included";
								obj.insulation_wall["p_f_w"] = true;
							}
							if (key == "storage_back" && tmpObj["storage_back"] == false && tmpObj["p_b_w"] == true && params.p_b_w == "Close" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)) {
								obj.insulation_wall[key] = "included";
								obj.insulation_wall["p_b_w"] = true;
							}

							if ((key == "open_roof" || key == "storage_roof") && tmpObj["full_roof"] == true && (params.cB_addStorage_check_left || params.cB_addStorage_check_right || params.p_u_c)) {
								obj.insulation_wall["open_roof"] = "included";
								obj.insulation_wall["storage_roof"] = "included";
							}

							if (key == "storage_front" && params.p_u_c && params.p_f_w == "Close" && storagePosition == "front") {
								obj.insulation_wall[key] = false;
							}
							if (key == "storage_back" && params.p_u_c && params.p_b_w == "Close" && storagePosition == "end") {
								obj.insulation_wall[key] = false;
							}
						} else {
							obj.insulation_wall[key] = false;
							if (key == "p_l_w" && tmpObj["storage_left"] == "included" && params.p_u_c) {
								obj.insulation_wall["storage_left"] = false;
							}
							if (key == "p_r_w" && tmpObj["storage_right"] == "included" && params.p_u_c) {
								obj.insulation_wall["storage_right"] = false;
							}
							if (key == "p_f_w" && tmpObj["storage_front"] == "included" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)) {
								obj.insulation_wall["storage_front"] = false;
							}
							if (key == "p_b_w" && tmpObj["storage_back"] == "included" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)) {
								obj.insulation_wall["storage_back"] = false;
							}
						}
					} else if (key != "full_roof") {
						if (params[key] == "Close") {
							obj.insulation_wall[key] = val;
							if (key == "p_l_w" && val == true && params.p_u_c && (obj.insulation_wall["storage_left"] == undefined || obj.insulation_wall["storage_left"] == false)) {
								obj.insulation_wall["storage_left"] = "included";
							}
							if (key == "p_r_w" && val == true && params.p_u_c && (obj.insulation_wall["storage_right"] == undefined || obj.insulation_wall["storage_right"] == false)) {
								obj.insulation_wall["storage_right"] = "included";
							}
							if (
								key == "p_f_w" &&
								(params.cB_addStorage_check_left || params.cB_addStorage_check_right) &&
								(obj.insulation_wall["storage_front"] == undefined || obj.insulation_wall["storage_front"] == false)
							) {
								obj.insulation_wall["storage_front"] = "included";
							}
							if (
								key == "p_b_w" &&
								(params.cB_addStorage_check_left || params.cB_addStorage_check_right) &&
								(obj.insulation_wall["storage_back"] == undefined || obj.insulation_wall["storage_back"] == false)
							) {
								obj.insulation_wall["storage_back"] = "included";
							}

							if (key == "p_l_w" && params.p_u_c && obj.insulation_wall["storage_left"] == true) {
								obj.insulation_wall[key] = true;
								obj.insulation_wall["storage_left"] = "included";
							}
							if (key == "p_r_w" && params.p_u_c && obj.insulation_wall["storage_right"] == true) {
								obj.insulation_wall[key] = true;
								obj.insulation_wall["storage_right"] = "included";
							}
						} else {
							obj.insulation_wall[key] = false;
							if (key == "p_l_w" && params.p_u_c) {
								obj.insulation_wall["storage_left"] = false;
							}
							if (key == "p_r_w" && params.p_u_c) {
								obj.insulation_wall["storage_right"] = false;
							}
							if (key == "p_f_w" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)) {
								obj.insulation_wall["storage_front"] = false;
							}
							if (key == "p_b_w" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)) {
								obj.insulation_wall["storage_back"] = false;
							}
						}
					} else if (key == "full_roof" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right || params.p_u_c)) {
						if (obj.insulation_wall["full_roof"] == true) {
							obj.insulation_wall["open_roof"] = "included";
							obj.insulation_wall["storage_roof"] = "included";
						}
						if (obj.insulation_wall["full_roof"] == false) {
							obj.insulation_wall["open_roof"] = obj.insulation_wall["open_roof"] || false;
							obj.insulation_wall["storage_roof"] = obj.insulation_wall["storage_roof"] || false;
						}
					}
				});
			}
		});
	}
	if (const_var.insulationArrayForLeantoFront) {
		const_var.insulationArrayForLeantoFront.forEach((obj) => {
			if (obj && obj.insulation_wall) {
				let tmpObj = JSON.parse(JSON.stringify(obj.insulation_wall));

				Object.entries(tmpObj).forEach(([key, val]) => {
					if (key == "storage_back" || key == "storage_front" || key == "storage_roof" || key == "storage_right" || key == "storage_left" || key == "open_roof") {
						let storagePosition = "";
						if (params.add_storage_check_front) {
							if (params.frontLeanStoragePosition <= 0) {
								storagePosition = "end";
							} else if (params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front) - 0.2) {
								storagePosition = "front";
							} else {
								storagePosition = "center";
							}
						}
						if (params.add_storage_check_front) {
							obj.insulation_wall[key] = val;
							if (key == "storage_left" && obj.insulation_wall["storage_left"] == "included" && params.p_b_c_b_f_l != "Close") {
								obj.insulation_wall[key] = true;
							}

							if (key == "storage_left" && (tmpObj["storage_left"] == true || tmpObj["storage_left"] == false) && tmpObj["p_b_c_b_f_l"] == true && params.p_b_c_b_f_l == "Close") {
								obj.insulation_wall[key] = "included";
								obj.insulation_wall["p_b_c_b_f_l"] = true;
							}
							if ((key == "open_roof" || key == "storage_roof") && tmpObj["full_roof"] == true && params.add_storage_check_front) {
								obj.insulation_wall["open_roof"] = "included";
								obj.insulation_wall["storage_roof"] = "included";
							}

							if (key == "storage_front" && params.p_b_c_b_f_f == "Close" && storagePosition == "front") {
								obj.insulation_wall[key] = false;
							}
							if (key == "storage_back" && params.p_b_c_b_f_b == "Close" && storagePosition == "end") {
								obj.insulation_wall[key] = false;
							}
						} else {
							obj.insulation_wall[key] = false;
							if (key == "p_b_c_b_f_l" && tmpObj["storage_left"] == "included" && params.add_storage_check_front) {
								obj.insulation_wall["storage_left"] = false;
							}
						}
					} else if (key != "full_roof") {
						if (params[key] == "Close") {
							obj.insulation_wall[key] = val;
							if (key == "p_b_c_b_f_l" && params.add_storage_check_front && (tmpObj["storage_left"] == undefined || tmpObj["storage_left"] == false)) {
								obj.insulation_wall["storage_left"] = "included";
							}
							if (key == "p_b_c_b_f_l" && params.add_storage_check_front && tmpObj["storage_left"] == true) {
								obj.insulation_wall[key] = true;
								obj.insulation_wall["storage_left"] = "included";
							}
						} else {
							obj.insulation_wall[key] = false;
							if (key == "p_b_c_b_f_l" && params.add_storage_check_front) {
								obj.insulation_wall["storage_left"] = false;
							}
						}
					} else if (key == "full_roof" && params.add_storage_check_front) {
						if (tmpObj["full_roof"] == true) {
							obj.insulation_wall["open_roof"] = "included";
							obj.insulation_wall["storage_roof"] = "included";
						}
						if (tmpObj["full_roof"] == false) {
							obj.insulation_wall["open_roof"] = obj.insulation_wall["open_roof"] || false;
							obj.insulation_wall["storage_roof"] = obj.insulation_wall["storage_roof"] || false;
						}
					}
				});
			}
		});
	}
	if (const_var.insulationArrayForLeantoBack) {
		const_var.insulationArrayForLeantoBack.forEach((obj) => {
			if (obj && obj.insulation_wall) {
				let tmpObj = JSON.parse(JSON.stringify(obj.insulation_wall));

				Object.entries(tmpObj).forEach(([key, val]) => {
					if (key == "storage_back" || key == "storage_front" || key == "storage_roof" || key == "storage_right" || key == "storage_left" || key == "open_roof") {
						let storagePosition = "";
						if (params.add_storage_check_back) {
							if (params.backLeanStoragePosition <= 0) {
								storagePosition = "end";
							} else if (params.backLeanStoragePosition === params.leanB_p_d - parseInt(params.add_storage_back) - 0.2) {
								storagePosition = "front";
							} else {
								storagePosition = "center";
							}
						}
						if (params.add_storage_check_back) {
							obj.insulation_wall[key] = val;
							if (key == "storage_right" && tmpObj["storage_right"] == "included" && params.p_b_c_b_b_l != "Close") {
								obj.insulation_wall[key] = true;
							}

							if (key == "storage_right" && (tmpObj["storage_right"] == true || tmpObj["storage_right"] == false) && tmpObj["p_b_c_b_b_l"] == true && params.p_b_c_b_b_l == "Close") {
								obj.insulation_wall[key] = "included";
								obj.insulation_wall["p_b_c_b_b_l"] = true;
							}
							if ((key == "open_roof" || key == "storage_roof") && tmpObj["full_roof"] == true && params.add_storage_check_back) {
								obj.insulation_wall["open_roof"] = "included";
								obj.insulation_wall["storage_roof"] = "included";
							}

							if (key == "storage_front" && params.p_b_c_b_b_f == "Close" && storagePosition == "front") {
								obj.insulation_wall[key] = false;
							}
							if (key == "storage_back" && params.p_b_c_b_b_b == "Close" && storagePosition == "end") {
								obj.insulation_wall[key] = false;
							}
						} else {
							obj.insulation_wall[key] = false;
							if (key == "p_b_c_b_b_l" && tmpObj["storage_right"] == "included" && params.add_storage_check_back) {
								obj.insulation_wall["storage_right"] = false;
							}
						}
					} else if (key != "full_roof") {
						if (params[key] == "Close") {
							obj.insulation_wall[key] = val;
							if (key == "p_b_c_b_b_l" && params.add_storage_check_back && (tmpObj["storage_right"] == undefined || tmpObj["storage_right"] == false)) {
								obj.insulation_wall["storage_right"] = "included";
							}
							if (key == "p_b_c_b_b_l" && params.add_storage_check_back && tmpObj["storage_right"] == true) {
								obj.insulation_wall[key] = true;
								obj.insulation_wall["storage_right"] = "included";
							}
						} else {
							obj.insulation_wall[key] = false;
							if (key == "p_b_c_b_b_l" && params.add_storage_check_back) {
								obj.insulation_wall["storage_right"] = false;
							}
						}
					} else if (key == "full_roof" && params.add_storage_check_back) {
						if (tmpObj["full_roof"] == true) {
							obj.insulation_wall["open_roof"] = "included";
							obj.insulation_wall["storage_roof"] = "included";
						}
						if (tmpObj["full_roof"] == false) {
							obj.insulation_wall["open_roof"] = obj.insulation_wall["open_roof"] || false;
							obj.insulation_wall["storage_roof"] = obj.insulation_wall["storage_roof"] || false;
						}
					}
				});
			}
		});
	}
	if (const_var.insulationArrayForLeantoLeft) {
		const_var.insulationArrayForLeantoLeft.forEach((obj) => {
			if (obj && obj.insulation_wall) {
				let tmpObj = JSON.parse(JSON.stringify(obj.insulation_wall));

				Object.entries(tmpObj).forEach(([key, val]) => {
					if (key == "storage_back" || key == "storage_front" || key == "storage_roof" || key == "storage_right" || key == "storage_left" || key == "open_roof") {
						let storagePosition = "";
						if (params.add_storage_check) {
							if (params.leftLeanStoragePosition === 0) {
								storagePosition = "end";
							} else if (params.leftLeanStoragePosition === params.lean_p_d - parseInt(params.add_storage)) {
								storagePosition = "front";
							} else {
								storagePosition = "center";
							}
						}
						if (params.add_storage_check) {
							obj.insulation_wall[key] = val;
							if (key == "storage_left" && tmpObj["storage_left"] == "included" && params.p_b_c_b_l != "Close") {
								obj.insulation_wall[key] = true;
							}
							if (key == "storage_left" && (tmpObj["storage_left"] == true || tmpObj["storage_left"] == false) && tmpObj["p_b_c_b_l"] == true && params.p_b_c_b_l == "Close") {
								obj.insulation_wall[key] = "included";
								obj.insulation_wall["p_b_c_b_l"] = true;
							}
							if ((key == "open_roof" || key == "storage_roof") && tmpObj["full_roof"] == true && params.add_storage_check) {
								obj.insulation_wall["open_roof"] = "included";
								obj.insulation_wall["storage_roof"] = "included";
							}

							if (key == "storage_front" && params.p_b_c_b_l_f == "Close" && storagePosition == "front") {
								obj.insulation_wall[key] = false;
							}
							if (key == "storage_back" && params.p_b_c_b_l_b == "Close" && storagePosition == "end") {
								obj.insulation_wall[key] = false;
							}
						} else {
							obj.insulation_wall[key] = false;
							if (key == "p_b_c_b_l" && tmpObj["storage_left"] == "included" && params.add_storage_check) {
								obj.insulation_wall["storage_left"] = false;
							}
						}
					} else if (key != "full_roof") {
						if (params[key] == "Close") {
							obj.insulation_wall[key] = val;
							if (key == "p_b_c_b_l" && params.add_storage_check && (tmpObj["storage_left"] == undefined || tmpObj["storage_left"] == false)) {
								obj.insulation_wall["storage_left"] = "included";
							}
							if (key == "p_b_c_b_l" && params.add_storage_check && tmpObj["storage_left"] == true) {
								obj.insulation_wall[key] = true;
								obj.insulation_wall["storage_left"] = "included";
							}
						} else {
							obj.insulation_wall[key] = false;
							if (key == "p_b_c_b_l" && params.add_storage_check) {
								obj.insulation_wall["storage_left"] = false;
							}
						}
					} else if (key == "full_roof" && params.add_storage_check) {
						if (tmpObj["full_roof"] == true) {
							obj.insulation_wall["open_roof"] = "included";
							obj.insulation_wall["storage_roof"] = "included";
						}
						if (tmpObj["full_roof"] == false) {
							obj.insulation_wall["open_roof"] = obj.insulation_wall["open_roof"] || false;
							obj.insulation_wall["storage_roof"] = obj.insulation_wall["storage_roof"] || false;
						}
					}
				});
			}
		});
	}
	if (const_var.insulationArrayForLeantoRight) {
		const_var.insulationArrayForLeantoRight.forEach((obj) => {
			if (obj && obj.insulation_wall) {
				let tmpObj = JSON.parse(JSON.stringify(obj.insulation_wall));

				Object.entries(tmpObj).forEach(([key, val]) => {
					if (key == "storage_back" || key == "storage_front" || key == "storage_roof" || key == "storage_right" || key == "storage_left" || key == "open_roof") {
						let storagePosition = "";
						if (params.add_storage_check_right) {
							if (params.rightLeanStoragePosition === 0) {
								storagePosition = "end";
							} else if (params.rightLeanStoragePosition === params.leanR_p_d - parseInt(params.add_storage_right)) {
								storagePosition = "front";
							} else {
								storagePosition = "center";
							}
						}
						if (params.add_storage_check_right) {
							obj.insulation_wall[key] = val;
							if (key == "storage_right" && tmpObj["storage_right"] == "included" && params.p_b_c_b_r != "Close") {
								obj.insulation_wall[key] = true;
							}
							if (key == "storage_right" && (tmpObj["storage_right"] == true || tmpObj["storage_right"] == false) && tmpObj["p_b_c_b_r"] == true && params.p_b_c_b_r == "Close") {
								obj.insulation_wall[key] = "included";
								obj.insulation_wall["p_b_c_b_r"] = true;
							}
							if ((key == "open_roof" || key == "storage_roof") && tmpObj["full_roof"] == true && params.add_storage_check_right) {
								obj.insulation_wall["open_roof"] = "included";
								obj.insulation_wall["storage_roof"] = "included";
							}

							if (key == "storage_front" && params.p_b_c_b_r_f == "Close" && storagePosition == "front") {
								obj.insulation_wall[key] = false;
							}
							if (key == "storage_back" && params.p_b_c_b_r_b == "Close" && storagePosition == "end") {
								obj.insulation_wall[key] = false;
							}
						} else {
							obj.insulation_wall[key] = false;
							if (key == "p_b_c_b_r" && tmpObj["storage_right"] == "included" && params.add_storage_check_right) {
								obj.insulation_wall["storage_right"] = false;
							}
						}
					} else if (key != "full_roof") {
						if (params[key] == "Close") {
							obj.insulation_wall[key] = val;
							if (key == "p_b_c_b_r" && params.add_storage_check_right && (tmpObj["storage_right"] == undefined || tmpObj["storage_right"] == false)) {
								obj.insulation_wall["storage_right"] = "included";
							}
							if (key == "p_b_c_b_r" && params.add_storage_check_right && tmpObj["storage_right"] == true) {
								obj.insulation_wall[key] = true;
								obj.insulation_wall["storage_right"] = "included";
							}
						} else {
							obj.insulation_wall[key] = false;

							if (key == "p_b_c_b_r" && params.add_storage_check_right) {
								obj.insulation_wall["storage_right"] = false;
							}
						}
					} else if (key == "full_roof" && params.add_storage_check_right) {
						if (tmpObj["full_roof"] == true) {
							obj.insulation_wall["open_roof"] = "included";
							obj.insulation_wall["storage_roof"] = "included";
						}
						if (tmpObj["full_roof"] == false) {
							obj.insulation_wall["open_roof"] = obj.insulation_wall["open_roof"] || false;
							obj.insulation_wall["storage_roof"] = obj.insulation_wall["storage_roof"] || false;
						}
					}
				});
			}
		});
	}
};
export const setHorizontalAndVerticalWalls = (dataNew, panelPrice) => {
	if (const_var.b_o_J_1[params.p_b_t] != "Custom Buildings") {
		if (dataNew?.side_close_cost != 0) {
			const_var.checkFunCalling = true;
		} else if (const_var.hide_price_calculation == 1 && dataNew.side_close_cost == 0) {
			params.p_v_w = false;
			params.wallTexture = const_var.selSidingOption == "metal" ? "none" : params.wallTexture;
			const_var.checkFunCalling = true;
		} else {
			if (dataNew?.vertical_side_cost != 0 && const_var.selSidingOption == "metal") {
				params.p_v_w = true;
				params.p_c_p_l = false;
				params.p_c_p_r = false;
				params.p_c_p_f = false;
				params.p_c_p_b = false;
				params.wallTexture = "vertical";
				const_var.checkFunCalling = false;
			}
		}
	} else {
		const_var.checkFunCalling = true;
	}
	if (const_var.selSidingOption != "metal") {
		if (const_var.selSidingObj.panel_price_from && const_var.selSidingObj.panel_price_from.length != 0 && const_var.selSidingObj.panel_price_from[0] == "vertical") {
			params.p_v_w = true;
		} else {
			if (const_var.selSidingOption.includes("board_and_batten")) {
				params.p_v_w = true;
			} else if (
				const_var.selSidingOption != "metal" &&
				(const_var.selSidingObj.panel_price_from == undefined || const_var.selSidingObj.panel_price_from?.length == 0) &&
				const_var.selSidingObj.price_type == "$" &&
				dataNew.side_close_cost == 0
			) {
				params.p_v_w = true;
			} else {
				params.p_v_w =
					params.wallOrientation == "vertical" && params.p_v_w == false
						? true
						: const_var.selSidingObj?.panel_price_from?.length > 0
							? const_var.selSidingObj?.panel_price_from?.[0] == "vertical"
							: params.p_v_w;
			}
		}
	}

	if (dataNew?.side_close_cost == 0) {
		if (params.p_v_w == false) {
			params.p_v_w = dataNew?.vertical_side_cost != 0 && const_var.selSidingOption == "metal" ? true : false;
			if (params.p_v_w) {
				params.wallTexture = const_var.selSidingOption == "metal" ? "vertical" : params.wallTexture;
				params.wallOrientation = const_var.selSidingOption == "metal" ? "vertical" : params.wallOrientation;
			} else {
				params.wallTexture = const_var.selSidingOption == "metal" ? "none" : params.wallTexture;
			}
			cuBuilding.BuildingUpdate(true, "");
		}
	}
	if (dataNew?.side_close_cost == 0) {
		const_var.checkVerticalCheckBox = true;
		if (params.p_v_w == false) {
			params.p_v_w = dataNew.vertical_side_cost != 0 && const_var.selSidingOption == "metal" ? true : false;
		}
		if (params.p_v_w) {
			params.wallTexture = const_var.selSidingOption == "metal" ? "vertical" : params.wallTexture;

			params.wallOrientation = !const_var.selSidingOption.includes("board_and_batten") && !const_var.selSidingOption.includes("lap") ? "vertical" : params.wallOrientation;
		} else {
			params.wallTexture = const_var.selSidingOption == "metal" ? "none" : params.wallTexture;
		}
	} else {
		if (const_var.selSidingObj?.panel_orientation?.length == 0) {
			if (const_var.selSidingObj.name == "metal") {
				params.wallOrientation = params.p_v_w ? "vertical" : "horizontal";
			} else {
				if (const_var.crmSetting.is_Edit) {
					params.wallOrientation = const_var.selSidingOption.includes("horizontal") ? "horizontal" : const_var.selSidingOption.includes("vertical") ? "vertical" : params.wallOrientation;
				} else {
					params.wallOrientation = "";
				}
			}
		} else if (const_var.selSidingObj?.panel_orientation?.length > 0) {
			if (const_var.selSidingObj.panel_orientation?.includes(params.wallOrientation)) {
				params.wallOrientation = params.wallOrientation;
			} else {
				if (const_var.selSidingObj.name == "metal") {
					params.wallOrientation = params.p_v_w ? "vertical" : "horizontal";
				} else {
					params.wallOrientation = const_var.selSidingObj?.panel_orientation?.[0];
				}
			}
		}
		const_var.checkFunCalling = true;
	}

	if (dataNew?.side_close_cost == 0 && dataNew.vertical_side_cost == 0) {
		const_var.checkVerticalCheckBox = false;
	}
	if (dataNew?.side_close_cost != 0) {
		const_var.checkVerticalCheckBox = false;
	}
	if (params.p_v_w || panelPrice?.cut_panel_cost == 0) {
		params.p_c_p_l = false;
		params.p_c_p_r = false;
		params.p_c_p_f = false;
		params.p_c_p_b = false;
	}
};
